import React, {useContext, useState, useEffect} from 'react';
import _ from "lodash";
import "./timetableManagementForm.scss";
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl';
import FixedHeaderTable from "../../components/FixedHeaderTable";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import IconButton from "@material-ui/core/IconButton";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {DatePicker} from "@material-ui/pickers";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import moment from "moment-timezone";
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Stack from '@mui/material/Stack';
import dayjs from "dayjs";

const columns = [
    { id: 'subjectName', label: 'Subject', minWidth: 170 },
    { id: 'programLvlLabel', label: 'Program Lvl', minWidth: 160 },
    { id: 'startTime', label: 'Start Time', minWidth: 130 },
    { id: 'endTime', label: 'End Time', minWidth: 130 },
    { id: 'classroom', label: 'Classroom', minWidth: 130 },
    { id: 'classSession', label: 'Session', minWidth: 130 },
    {
        id: 'recordCreateDate',
        label: 'Created Date',
        minWidth: 150,
        align: 'right',
        format: (value) => {
            return value? moment(value, "YYYY-MM-DD HH:mm:ss").tz("Asia/Singapore").format('YYYY-MM-DD HH:mma') : "NA"},
    },
    {
        id: 'action',
        label: 'Action',
        minWidth: 170,
        align: 'right',
    },
];

const TimetableManagement = () => {
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { uuid } = state.formStates.studentRegistration; // get field data from global state
    const { setFormData } = actions.formActions; // export setFormData function
    const { displayConfirmDialog, getTimetables, updateTimetable, createTimetable } = actions.generalActions;
    const { getAllCourses, getAllProgramLvl } = actions.registrationActions;
    const { timetables } = state.generalStates;
    const studentProgramLvl = state.registrationStates.programLvl;
    const courses = state.registrationStates.courses;
    const [isDialogVisible, setDialogVisibility] = useState(false);
    const [course, setCourse] = useState(null);
    const [timetableId, setTimetableId] = useState(null);
    const [programLvl, setProgramLvl] = useState(null);
    const [session, setSession] = useState(null);
    const [classroom, setClassroom] = useState(null);
    const [dayOfWeek, setDayOfWeek] = useState(null);
    const [errorMsg, setErrorMsg] = useState("");
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const dayJsFormat = "HHmm";


    useEffect(() => {
        getTimetables();
        getAllCourses();
        getAllProgramLvl();
    }, []);

    // useEffect(() => {
    //     if (tuitionFees.length > 0) {
    //         setCourses(_.uniqBy(tuitionFees, 'courseId'));
    //         setProgramLvl(_.uniqBy(tuitionFees, 'programLvl'));
    //     }
    // }, [tuitionFees])

    const handleProgramLvlOnChange = (e) =>{
        console.log(e.target.value);
        setProgramLvl(e.target.value);
    };

    const handleSessionOnChange = (e) =>{
        console.log(e.target.value);
        setSession(e.target.value);
    };

    const handleCourseOnChange = (e) =>{
        setCourse(e.target.value);
    };


    const goBack = () => {
        history.push("/student/management")
    }

    const handleCreateButton = () => {
        clearAll();
        setDialogVisibility(true);
    }

    const onEditClick = () => {
        history.push("/student/management")
    }

    const handleSubmit = () => {
        if (!course) {
            setErrorMsg("Please fill in the course")
            return;
        }

        if (!programLvl) {
            setErrorMsg("Please fill in the program lvl")
            return;
        }

        if (!session) {
            setErrorMsg("Please fill in the class session")
            return;
        }

        const startTimeFormat = dayjs(startTime).format(dayJsFormat);
        const endTimeFormat = dayjs(endTime).format(dayJsFormat);
        if (!timetableId) {
            createTimetable(startTimeFormat, endTimeFormat, dayOfWeek, course, programLvl, classroom, session)
        } else {
            updateTimetable(timetableId, startTimeFormat, endTimeFormat, dayOfWeek, course, programLvl, classroom, session);
        }
        clearAll();
        setDialogVisibility(false);
    };

    const handleClose = () => {
        clearAll();
        setDialogVisibility(false);
    };

    const handleDelete = () => {
        displayConfirmDialog(
            true,
            "Confirmation",
            "Are you sure you want to delete this schedule?",
            false,
            (month) => {
                const startTimeFormat = dayjs(startTime).format(dayJsFormat);
                const endTimeFormat = dayjs(endTime).format(dayJsFormat);
                updateTimetable(timetableId, startTimeFormat, endTimeFormat, dayOfWeek, course, programLvl, classroom, "DELETED");
                clearAll();
                setDialogVisibility(false)
            }
        )
    };

    const clearAll = () => {
        setTimetableId(null);
        setCourse(null);
        setProgramLvl(null);
        setStartTime(null);
        setEndTime(null);
        setDayOfWeek(null);
        setClassroom(null);
    }

    const renderStartEndTimeRange = () => {
        return (
            <div>
                <Stack direction="row" spacing={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                            minutesStep={5}
                            label="Start Time"
                            value={startTime}
                            onChange={(newValue) => {
                                setStartTime(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                            label="End Time"
                            minutesStep={5}
                            value={endTime}
                            onChange={(newValue) => {
                                setEndTime(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                </Stack>
            </div>
        )
    }

    const renderAllCourses = () =>{
        return (
            <FormControl fullWidth variant="standard" margin="dense">
                <InputLabel>Course</InputLabel>
                <Select fullWidth value={course} onChange={(e, val) => handleCourseOnChange(e)}>
                    {
                        courses && courses.map((value, index) => {
                            return (
                                <MenuItem fullWidth key={value.id} value={value.id}>{value.name}</MenuItem>
                            );
                        })
                    }
                </Select>
            </FormControl>
        )
    };

    const renderAllProgramLvl = () =>{
        return (
            <FormControl fullWidth variant="standard" margin="dense">
                <InputLabel>Program Level</InputLabel>
                <Select fullWidth value={programLvl} onChange={(e) => handleProgramLvlOnChange(e)}>
                    {
                        studentProgramLvl && studentProgramLvl.length > 0 && studentProgramLvl.map((value, index) => {
                            if (studentProgramLvl.length > 0 && value) {
                                const programLvlName = _.find(studentProgramLvl, {id: value.id}).name;
                                return (
                                    <MenuItem fullWidth key={value.id}
                                              value={value.id}>{programLvlName}</MenuItem>
                                );
                            }
                        })
                    }
                </Select>
            </FormControl>
        )
    };

    const renderSessions = () =>{
        return (
            <FormControl fullWidth variant="standard" margin="dense">
                <InputLabel>Session</InputLabel>
                <Select fullWidth value={session} onChange={(e) => handleSessionOnChange(e)}>
                    <MenuItem fullWidth key={"MORNING"}
                              value={"MORNING"}>MORNING</MenuItem>
                    <MenuItem fullWidth key={"AFTERNOON"}
                              value={"AFTERNOON"}>AFTERNOON</MenuItem>
                </Select>
            </FormControl>
        )
    };

    const onViewDetailClick = (id) => {
        let detail = _.find(timetables, {id});
        setTimetableId(id);
        setCourse(detail.subjectId);
        setProgramLvl(detail.programLvl);
        setStartTime(dayjs(detail.startTime, dayJsFormat));
        setEndTime(dayjs(detail.endTime, dayJsFormat));
        setDayOfWeek(detail.dayOfWeek);
        setClassroom(detail.classroom);
        setSession(detail.classSession);
        // setCourse(coursesFilter);
        setDialogVisibility(true);
    };

    const monTimetable = _.filter(timetables, { dayOfWeek: 1 });
    const tuesTimetable = _.filter(timetables, { dayOfWeek: 2 });
    const wedTimetable = _.filter(timetables, { dayOfWeek: 3 });
    const thursTimetable = _.filter(timetables, { dayOfWeek: 4 });
    const fridayTimetable = _.filter(timetables, { dayOfWeek: 5 });

    return (
        <div className="timetable-management-form-container">
            <IconButton className="arrowBack" aria-label="back" onClick={() => {goBack()}}>
                <ArrowBackIosIcon fontSize="small" color="primary"/> <span>BACK</span>
            </IconButton>
            <h1 className="header">Timetable Management</h1>
            <div className="paperContainer">
                <Button className="create-btn" variant="contained" color="primary" onClick={handleCreateButton}>
                    Create
                </Button>
            </div>
            <div className="table-container">
                <h2>Monday</h2>
                {monTimetable && <FixedHeaderTable columns={columns} rows={monTimetable} buttonContent="Edit" buttonAction={onViewDetailClick}/>}
            </div>
            <div className="table-container">
                <h2>Tuesday</h2>
                {tuesTimetable && <FixedHeaderTable columns={columns} rows={tuesTimetable} buttonContent="Edit" buttonAction={onViewDetailClick}/>}
            </div>
            <div className="table-container">
                <h2>Wednesday</h2>
                {wedTimetable && <FixedHeaderTable columns={columns} rows={wedTimetable} buttonContent="Edit" buttonAction={onViewDetailClick}/>}
            </div>
            <div className="table-container">
                <h2>Thursday</h2>
                {thursTimetable && <FixedHeaderTable columns={columns} rows={thursTimetable} buttonContent="Edit" buttonAction={onViewDetailClick}/>}
            </div>
            <div className="table-container">
                <h2>Friday</h2>
                {fridayTimetable && <FixedHeaderTable columns={columns} rows={fridayTimetable} buttonContent="Edit" buttonAction={onViewDetailClick}/>}
            </div>

            <Dialog open={isDialogVisible} onClose={handleClose} aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth = {'md'}>
                <DialogTitle id="form-dialog-title"><h2>Timetable Detail</h2></DialogTitle>
                <DialogContent>
                    {renderAllCourses()}
                    {renderAllProgramLvl()}
                    {renderStartEndTimeRange()}
                    {renderSessions()}
                    <TextField margin="dense" label="Classroom"
                               value={classroom} fullWidth
                               onChange={ e => setClassroom(e.target.value)}
                    />
                    <TextField margin="dense" label="Day of week (1-7)"
                               value={dayOfWeek} fullWidth
                               type={"number"}
                               onChange={ e => setDayOfWeek(e.target.value)}
                    />
                    <div className="inline-error">{errorMsg}</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Delete
                    </Button>
                    <Button onClick={handleSubmit} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default withRouter(TimetableManagement);
